import Immutable from 'seamless-immutable';

import { register } from '@src/dispatcher';
import createStore from '@src/stores/StoreUtils';
import { ACTION_TYPES } from '../const';

class Store {
  state = Immutable({
    businessDataOriginal: {},
    businessData: {},
    businessDataEdited: false,
    businessDataErrors: [],
    partnerIdMap: [],
    templateBotList: [],
    botList: [],
    lactList: [],
    allTeams: [],
    allPlatforms: [],
    allClients: [],
    supportedLanguages: [],
  });

  constructor() {
    this.reducer = this.reducer.bind(this);
    this.registrer = this.registrer.bind(this);
    this.getState = this.getState.bind(this);
    this.getStateImmutable = this.getStateImmutable.bind(this);
    this._Store = createStore(this.state);
    this._Store.dispatchToken = register(this.registrer);
  }

  registrer(props) {
    this.state = this.reducer(props);
    this._Store.emitChange();
  }

  reducer({ action, type: actionType }) {
    const { state } = this;
    switch (actionType) {
      case ACTION_TYPES.CREATE_NEW_BUSINESS:
      case ACTION_TYPES.RECEIVED_BUSINESS_DATA:
        if (action.meta) {
          return state.merge({
            // @TODOOOOOO::::: BusinessStore.resetData();
            businessDataEdited: false,
            businessData: action.data,
            partnerIdMap: action.meta.partner_id_map,
            botList: action.meta.domain_list,
            lactList: action.meta.chat_tools,
            templateBotList: action.meta.template_bot_list,
            supportedLanguages: action.meta.language_list,
            allPlatforms: action.meta.allPlatforms || state.allPlatforms,
            allTeams: action.meta.allTeams || state.allTeams,
            allClients: action.meta.allClients || state.allClients,
          });
        }

        return state.merge({
          businessDataEdited: false,
          businessData: action.data,
          businessDataOriginal: action.data,
        });

      case ACTION_TYPES.EDITED_BUSINESS_DATA:
        return state.merge({
          businessDataEdited: true,
          businessData: action.data,
        });

      case ACTION_TYPES.VALIDATED_BUSINESS_DATA:
        return state.merge({
          businessDataErrors: action.data,
        });

      default:
        return state;
    }
  }

  getState() {
    return this.state;
  }

  getStateImmutable() {
    return this.state;
  }

  getStore() {
    return this._Store;
  }
}

export default new Store();
